import { Dialog, Portal, Progress } from "@ark-ui/react";
import { Merge } from "type-fest";

import { useTranslate } from "../../services";
import { dialogStyles, progressStyles } from "../common";

export type ProgressOverlayProperties = Merge<Dialog.RootProps, { open?: never; progress: number }>;

export function ProgressOverlay({ progress, ...properties }: ProgressOverlayProperties) {
  const translate = useTranslate();
  const dialogClasses = dialogStyles();
  const progressClasses = progressStyles();
  return (
    <Dialog.Root {...properties} open={progress !== 100}>
      <Portal>
        <Dialog.Backdrop className={dialogClasses.backdrop} />
        <Dialog.Positioner className={dialogClasses.positioner}>
          <Dialog.Content asChild>
            <Progress.Root className={progressClasses.root} value={progress}>
              <Progress.Label className={progressClasses.label}>
                {translate("%Processing.0%")}
              </Progress.Label>
              <Progress.Track className={progressClasses.track}>
                <Progress.Range className={progressClasses.range} />
              </Progress.Track>
              <Progress.ValueText className={progressClasses.valueText} />
            </Progress.Root>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
